export enum PaymentType {
  StandardPayment = 'StandardPayment',
  Cash = 'Cash',
  CreditDebitCard = 'CreditDebitCard',
}
